import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/promiseFrame/deffectiveReport.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7e7de39f")

_pushScopeId("data-v-7e7de39f")
const _hoisted_1 = { class: "deffectiveReport" }
const _hoisted_2 = { class: "deffectiveReport_main" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "deffectImg",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1)
const _hoisted_4 = { class: "tipTxt" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.state.renderTxt), 1)
    ])
  ]))
})